export default __webpack_public_path__ + "static/media/thoughts.ce35281f.svg";